"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferredTpaDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const tpa_entity_1 = require("./tpa.entity");
const contact_entity_1 = require("./contact.entity");
const opportunity_broking_slip_version_entity_1 = require("./opportunity-broking-slip-version.entity");
let PreferredTpaDetails = class PreferredTpaDetails {
};
exports.PreferredTpaDetails = PreferredTpaDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetails.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tpa_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetails.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "location_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetails.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "branch_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetails.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetails.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => tpa_entity_1.Tpa),
    (0, typeorm_1.JoinColumn)({ name: "tpa_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], PreferredTpaDetails.prototype, "tpa", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], PreferredTpaDetails.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails, (brokingSlip) => brokingSlip.preferredTpaDetails, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], PreferredTpaDetails.prototype, "brokingSlip", void 0);
exports.PreferredTpaDetails = PreferredTpaDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "brokingslip_version_preferred_tpa_detail" })
], PreferredTpaDetails);
